import React, { useState, useRef } from 'react';

const TextManipulator = ({ elementType, defaultValue }) => {
  const [text, setText] = useState(defaultValue || '');
  const inputRef = useRef();

  const handleAppendText = (newText) => {
    setText((prevText) => prevText + newText);
  };

  const handleReplaceText = (newText) => {
    setText(newText);
  };
  

  const handleInsertTextAtCursor = (newText) => {
    const input = inputRef.current;

    if (input) {
      const start = input.selectionStart;
      const end = input.selectionEnd;

      setText((prevText) => prevText.substring(0, start) + newText + prevText.substring(end));
    }
  };

  const handleReplaceSelectedText = (newText) => {
    const input = inputRef.current;

    if (input) {
      const start = input.selectionStart;
      const end = input.selectionEnd;

      setText((prevText) => prevText.substring(0, start) + newText + prevText.substring(end));
    }
  };

  const inputProps = {
    value: text,
    onChange: (e) => setText(e.target.value),
    ref: inputRef,
  };

  let inputElement;

  switch (elementType) {
    case 'textarea':
      inputElement = <textarea {...inputProps} rows={4} cols={50} />;
      break;
    case 'input':
      inputElement = <input {...inputProps} />;
      break;
    case 'contenteditable':
      inputElement = (
        <div
          contentEditable
          {...inputProps}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      );
      break;
    default:
      throw new Error('Invalid element type');
  }

  return (
    <div>
      {inputElement}

      <button onClick={() => handleAppendText(' Appended Text')}>Append Text</button>
      <button onClick={() => handleReplaceText('Replaced Text')}>Replace All Text</button>
      <button onClick={() => handleInsertTextAtCursor('Inserted Text')}>Insert at Cursor</button>
      <button onClick={() => handleReplaceSelectedText('Replaced Selected Text')}>Replace Selected Text</button>
    </div>
  );
};

export default TextManipulator;
